import React from 'react';
import { useNavigate } from 'react-router-dom';

import { applyTypography, BaseButton } from '@repo/common';
import { ReactComponent as SuccessIcon } from '@repo/common/assets/icons/32px/icon_32px_check-circle_filled.svg';

const TXT_TITLE_KEY = 'h5';
const TXT_SUB_KEY = 'b16';
const TXT_TITLE_MOBILE_KEY = 'h7';

const ForgotPasswordNewSuccess = () => {
  const navigate = useNavigate();

  const handleGoButtonClick = () => {
    navigate('/login');
  };

  return (
    <div className='flex items-center justify-center w-full min-h-screen px-4 py-20 bg-grayscale-gray01 tabletH:p-0'>
      <div className='w-full flex flex-col items-center text-center px-6 pb-[100px] tabletH:px-0 tabletH:pb-0'>
        <div className='flex items-center justify-center w-[90px] h-[90px] relative mb-4'>
          <div className='w-[90px] h-[90px] rounded-full border-[24px] border-green-light02' />
          <div className='absolute inset-0 flex items-center justify-center top-[2px]'>
            <div className='w-[60px] h-[60px] flex items-center justify-center'>
              <SuccessIcon className='w-full h-full text-icon-success' />
            </div>
          </div>
        </div>

        <div
          className={`${applyTypography(
            TXT_TITLE_MOBILE_KEY
          )} text-text-primary flex items-center justify-center mb-1 tabletH:${applyTypography(
            TXT_TITLE_KEY
          )} tabletH:mb-2`}
        >
          Password reset!
        </div>
        <div
          className={`${applyTypography(
            TXT_SUB_KEY
          )} text-text-tertiary whitespace-normal mb-8 tabletH:whitespace-nowrap`}
        >
          Your password has been updated
          <br />
          You can now log in with your new password
        </div>
        <div className='w-full flex justify-center items-center tabletH:w-[380px]'>
          <BaseButton
            type='primary'
            size='l'
            hideIcon
            width='100%'
            onClick={handleGoButtonClick}
          >
            Go to login
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordNewSuccess;
